
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantId]/lessons/[templateId]/edit",
      function () {
        return require("private-next-pages/[tenantId]/lessons/[templateId]/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantId]/lessons/[templateId]/edit"])
      });
    }
  